/** v1 block types from 01-db.md — unknown types round-trip; these are validated for placement rules. */
export const PAGE_BLOCK_TYPE = 'page' as const;
export const DATABASE_BLOCK_TYPE = 'database' as const;

export const CONTENT_BLOCK_TYPES = [
  'paragraph',
  'heading',
  'bulletListItem',
  'numberedListItem',
  'checkListItem',
  'image',
  'file',
  'codeBlock',
  'quote',
  'divider',
] as const;

export type ContentBlockType = (typeof CONTENT_BLOCK_TYPES)[number];

export const KNOWN_BLOCK_TYPES = [
  PAGE_BLOCK_TYPE,
  DATABASE_BLOCK_TYPE,
  ...CONTENT_BLOCK_TYPES,
] as const;

export type KnownBlockType = (typeof KNOWN_BLOCK_TYPES)[number];

const contentBlockTypeSet = new Set<string>(CONTENT_BLOCK_TYPES);

export function isPageType(type: string): boolean {
  return type === PAGE_BLOCK_TYPE;
}

export function isDatabaseType(type: string): boolean {
  return type === DATABASE_BLOCK_TYPE;
}

export function isContentBlockType(type: string): boolean {
  return contentBlockTypeSet.has(type);
}

export function isKnownBlockType(type: string): type is KnownBlockType {
  return (KNOWN_BLOCK_TYPES as readonly string[]).includes(type);
}
